export default "__VITE_ASSET__a74e8c2e__"